export default "__VITE_ASSET__ffd29fb0__"